<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li
        style="display: flex; align-items: center"
        v-if="
          $store.state.loginUser?.IsAdmin ||
          $store.state.loginUser?.Qxs?.includes('B_DaoYou_List_添加')
        "
      >
        <el-button
          type="primary"
          icon="Plus"
          link
          @click="
            delete state.selectId;
            state.showCompile = true;
          "
        >
          添加
        </el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="IsQy"
          sortable="IsQy"
          label="状态"
          align="center"
          width="80"
        >
          <template #default="scope">
            <text :style="{ color: scope.row.IsQy ? '#080' : '#f00' }">
              {{ scope.row.IsQy ? "正常" : "停用" }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="Xm"
          sortable="Xm"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
        />
        <el-table-column
          prop="Xb"
          label="性别"
          width="60"
          :formatter="$tab_StatusFormat"
        />
        <el-table-column prop="Yz" label="语种" :formatter="$tab_TextFormat" />
        <el-table-column prop="Dj" label="等级" :formatter="$tab_TextFormat" />
        <el-table-column
          prop="Zjh"
          label="证件号"
          :formatter="$tab_TextFormat"
        />
        <el-table-column prop="Lx" label="类型" :formatter="$tab_TextFormat" />
        <el-table-column
          prop="Yxq"
          label="有效期"
          :formatter="$tab_TextFormat"
        />
        <el-table-column prop="Bz" label="备注" :formatter="$tab_TextFormat" />
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="120"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="
                state.selectId = row.Id;
                state.showCompile = true;
              "
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_DaoYou_List_编辑')
              "
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_DaoYou_List_删除')
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="(state.selectId ? '修改' : '添加') + '导游'"
        @close="state.showCompile = false"
      >
        <c_DaoYouCompile
          @close="
            state.showCompile = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_DaoYouCompile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { daoyou_list, daoyou_delete } from "@/http/api";
import { confirm_func } from "@/util/tFormat";

export default {
  setup() {
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: {},
        Order: "Cjsj",
        Asc: false,
      },
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      daoyou_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Cjsj",
          Asc: false,
        },
      });
      onLoad();
    };

    const onDelete = (id) => {
      confirm_func(daoyou_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style scoped lang="less"></style>
